import Config from '../../../config';

// Articles live at help.ginastee.com (pt-br tree). Paths are relative so the
// base can follow `Config.help` per environment.
const HELP_BASE = (Config.help || 'https://help.ginastee.com').replace(/\/$/, '');

export const HELP_CENTER_URL = HELP_BASE;

export function helpArticleUrl(path) {
    return `${HELP_BASE}${path}`;
}

// `title` holds a translation key (dashboard namespace) resolved at render, and
// `category` a stable identifier the card maps to a leading glyph — never a
// display string, so both survive a language change.

// Creator-oriented suggestions (shown to users who own ≥1 community).
const OWNER_ARTICLES = [
    {
        title: 'home.help.articles.wallet',
        category: 'financial',
        path: '/pt-br/financeiro-wallet-e-saques/como-configurar-sua-wallet-no-ginastee',
    },
    {
        title: 'home.help.articles.withdrawal',
        category: 'financial',
        path: '/pt-br/financeiro-wallet-e-saques/como-solicitar-um-saque',
    },
    {
        title: 'home.help.articles.plans',
        category: 'sales',
        path: '/pt-br/vendas-planos-e-cupons/como-criar-planos-para-vender-sua-comunidade',
    },
    {
        title: 'home.help.articles.sales',
        category: 'financial',
        path: '/pt-br/financeiro-wallet-e-saques/como-acompanhar-vendas-assinaturas-e-cobrancas',
    },
    {
        title: 'home.help.articles.coupons',
        category: 'sales',
        path: '/pt-br/vendas-planos-e-cupons/como-criar-e-usar-cupons-de-desconto',
    },
];

// Member-oriented suggestions (shown to users who own no community).
const MEMBER_ARTICLES = [
    {
        title: 'home.help.articles.access',
        category: 'account',
        path: '/pt-br/conta-perfil-e-acesso/por-que-nao-consigo-acessar-uma-comunidade-ou-conteudo',
    },
    {
        title: 'home.help.articles.firstCommunity',
        category: 'gettingStarted',
        path: '/pt-br/primeiros-passos/como-criar-e-publicar-sua-primeira-comunidade',
    },
    {
        title: 'home.help.articles.cancelSubscription',
        category: 'billing',
        path: '/pt-br/cancelamento-reembolso-e-cobrancas/como-cancelar-minha-assinatura',
    },
];

export function pickHelpArticles(audience = 'member') {
    const list = audience === 'owner' ? OWNER_ARTICLES : MEMBER_ARTICLES;
    return list.map(a => ({ ...a, url: helpArticleUrl(a.path) }));
}
